import {
  Label,
  Table,
  TableMetadata,
  useTable,
  Tooltip,
  IconWrapper,
  ArrowButton
} from "@king-ict/eupisi-ui/components";
import { ReactComponent as InfoIcon } from "@king-ict/eupisi-ui/components/Icon/Info.svg";
import { hrDate } from "@king-ict/eupisi-ui/utils";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import { PreviousPage, ProgramRequestStatusHistory } from "../../models/ProgramRequest";
import { programRequestDetailsUrl } from "../../routes/routes";
import { getProgramRequestStatusColor } from "../../utils/programRequestUtils";
import styles from "./ProgramRequestDetails.module.scss";

type ProgramRequestHistoryProps = {
  programRequestId: number;
  requestHistory: ProgramRequestStatusHistory[];
}
export function ProgramRequestHistoryPanel({ programRequestId, requestHistory }: ProgramRequestHistoryProps): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation<{ previousPage: PreviousPage, historyId?: number }>();

  const detailsOnClick = (id: number) => {
    history.push(programRequestDetailsUrl(programRequestId), { previousPage: location.state.previousPage, historyId: id });
  }

  const programRequestTableMetadata: TableMetadata<ProgramRequestStatusHistory> = {
    rowKey: "id",
    columns: [
      {
        columnKey: "programHistoryDate",
        header: t("common.date"),
        accessor: (item: ProgramRequestStatusHistory) => hrDate(item.dateCreted),
      },
      // {
      //   columnKey: "programHistorytUser",
      //   header: t("common.user"),
      //   accessor: (item: ProgramRequestStatusHistory) => item.userName,
      //   color: "success",
      // },
      {
        columnKey: "programHistoryStatus",
        header: t("common.programRequestStatus"),
        accessor: (item) => {
          return (
            <div className={"d-flex align-center"}>
              <Label color={getProgramRequestStatusColor(item.requestStatusId)}>
                {item.requestStatus}
              </Label>
            </div>
          );
        }
      },
      {
        columnKey: "processingDeadline",
        header: t("request.resolutionModalProcessingDeadline"),
        accessor: (item: ProgramRequestStatusHistory) => item.processingDeadline
      },
      {
        columnKey: "programHistoryDescription",
        header: t("common.description"),
        accessor: (item) => {
          if (item.description) {
            return (
              <Tooltip
                overlay={<div className={styles.infoTooltip}>{item.description}</div>}
                placement="bottom"
                flip
              >
                <IconWrapper color="primary">
                  <InfoIcon />
                </IconWrapper>
              </Tooltip>
            );
          }
          else {
            return "";
          }
        }
      },
      {
        columnKey: "details",
        header: "",
        accessor: (item) => {
          return (
            <div className={"text-right"}>
              {item.requestDetailId &&
                <ArrowButton ariaLabel="" onClick={() => detailsOnClick(item.id)} />
              }
            </div>

          )
        }
      }
    ],
    rowToolTip: () => undefined
  };

  var [tableProps] = useTable<ProgramRequestStatusHistory>(
    {
      metadata: programRequestTableMetadata,
      data: requestHistory,
      pagination: false,
      totalItems: requestHistory.length,
    }
  );

  return (
    <>
      <Table {...tableProps} />
    </>
  );
}